import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProviderService } from 'src/app/shared/services/provider.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  list: MyList[] = [
    { title: 'Пользователи', route: 'users/list', icon: 'user'},
    { title: 'Роли', route: 'roles/list', icon: 'permission'},
    { title: 'Папки БД', route: 'folders', icon: 'folder' },
    { 
      title: 'Портал гарантирования', 
      icon: 'user',
      expanded: false, 
      subItems: [
        { title: 'Куратор ИК', route: 'users-fgjs/list', icon: 'user' },
        { title: 'Сотрудник ИК', route: 'ik-employee', icon: 'user' },
        { title: 'Руководитель ИК', route: 'ik-manager', icon: 'user' },
        { title: 'Куратор ДМП', route: 'users-dpm/list', icon: 'user' },
      ]
    }
  ];

  userName = '';

  constructor(private router: Router, private service: ProviderService) { }

  ngOnInit() {
    this.userName = localStorage.getItem('PortalLoginManager') || '';
  }

  exit() {
    this.router.navigate(['login']);
    localStorage.removeItem('PortalLoginManager');
    localStorage.removeItem('PortalTokenManager');
  }

  toggleMenu(item: MyList) {
    if (item.subItems) {
      item.expanded = !item.expanded;
    }
  }
}

interface MyList {
  title: string;
  route?: string;
  icon: string;
  subItems?: MyList[];
  expanded?: boolean;
}